<div>
  <div class="row">
    <div class="header">
      <h1>Global compliance</h1>
      <p class="sub-header">
        Cerberus provides a consolidated view of compliance risk across the
        enterprise. This page presents the overall risk status for the Oncology,
        Biopharmaceuticals, and Rare Disease business units, along with the key
        activities that contribute to their scores. You may review each unit in
        more detail and examine underlying risk factors. <br />
        <span class="dates-legend"
          >Cerberus contains data from {{ firstDate }} through
          {{ lastDate }}.</span
        >
      </p>
    </div>
    <div>
      <app-risk-score-diagram />
    </div>
  </div>
  <div class="row">
    <h2 class="title">General</h2>
    <div class="action-buttons">
      <!-- view selection toggle -->
      <section>
        <mat-button-toggle-group
          aria-label="view selection"
          hideSingleSelectionIndicator
          [value]="currentView"
          (valueChange)="setView($event)"
          name="view-selection-group"
        >
          <mat-button-toggle
            value="graph"
            name="column-view-button"
            aria-label="view as graph button"
          >
            <mat-icon>view_column</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle
            value="list"
            name="list-view-button"
            aria-label="view as list button"
          >
            <mat-icon>view_list</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
        <button
          class="primary"
          [matMenuTriggerFor]="menu"
          aria-label="Open actions menu"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button class="secondary" (click)="openFilterDialog()">
            <mat-icon>filter_alt</mat-icon>
            Filter
          </button>
          <button class="secondary" (click)="openDateRangePicker()">
            <mat-icon>calendar_month</mat-icon>
            Date Range
          </button>
          <button class="secondary" *ngIf="false">
            <mat-icon>download</mat-icon>Download
          </button>
          <button class="secondary" *ngIf="false">
            <mat-icon>dashboard_customize</mat-icon>Custom
          </button>
        </mat-menu>
      </section>
    </div>
  </div>
  <div class="row">
    <!-- filter visualizer -->
    <app-filter-visualizer (filterCleared)="reloadData()" />
  </div>
  <div class="main-content" *ngIf="!isLoading; else loading">
    <div *ngIf="currentView === 'graph' && data.length > 0">
      <app-graph-view [data]="data" />
    </div>
    <div *ngIf="currentView === 'list' && data.length > 0">
      <app-list-view [data]="data" />
    </div>
  </div>
  <ng-template #loading>
    <div class="loading">
      <app-spinner
        [display]="true"
        [class]="'spinner-container'"
        [messageToDisplay]="'Loading data...'"
      ></app-spinner>
    </div>
  </ng-template>
</div>
